import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

type InfoFieldProps = {
  label: string;
  value: ReactNode;
  unit?: string;
};

export function InfoField({ label, value, unit }: InfoFieldProps) {
  return (
    <Box>
      <Typography gutterBottom>{label}</Typography>
      <Box
        sx={(theme) => ({
          backgroundColor:
            theme.vars.palette.backgrounds.neutral.moderate.default,
          padding: 1,
          borderRadius: theme.spacing(0.5),
          display: "flex",
          justifyContent: "space-between",
        })}
      >
        <Typography>{value}</Typography>
        {unit && <Typography>{unit}</Typography>}
      </Box>
    </Box>
  );
}
